import React from 'react'
import Tokens from '../ChatApp/Tokens';
import MessageItem from '../MessageItem/MessageItem';
import { useSelector } from 'react-redux';
import { selectIsAwaitingRole, selectRatingMessageId, selectSelectedSubOption } from '../ChatApp/chatSlice';
import { backIcon } from '../../static/svgs';
import './ChatContainer.css'
import { selectIsStart } from '../Login/loginSlice';
import ChatCategories from '../ChatCategories/ChatCategories';
import { FiSidebar } from 'react-icons/fi';

const ChatContainer = ({
    messages,
    // selectedSubOption,
    topic,
    handleClickToDialogs,
    // backIcon,
    // ratingMessageId,
    handleRating,
    // isAwaitingRole,
    isAwaitingDetails,
    isAwaitingQuestion,
    isAwaitingRateComment,
    role,
    handleRoleSelection,
    handleSkipToDialog,
    handleSkipRateComment,
    isWaiting,
    renderMessageInput,
    formatText,
    progress,
    waitingText,
    showProgressBar,
    isSubscription,
    // test,
    setChatType,
    userId
}) => {
    const selectedSubOption = useSelector(selectSelectedSubOption)
    const ratingMessageId = useSelector(selectRatingMessageId)
    const isAwaitingRole = useSelector(selectIsAwaitingRole)
    const isStart = useSelector(selectIsStart)

    return (
        <div className="chat-container">
            <ChatCategories setChatType={setChatType} userId={userId} handleClickToDialogs={handleClickToDialogs} />


            {/* <div className='back_icon' onClick={handleClickToDialogs}>
                <FiSidebar
                            className='sidebar_mover'
                            data-tooltip-id="custom-tooltip"
                            data-tooltip-content="Свернуть/развернуть меню"
                            data-tooltip-place="right"
                          />
            </div> */}
            <div className="messages">
                {/* {messages.length === 0 || (!isSubscription && !test) ? (
                    <div className="empty-messages">
                        <p>
                            {isStart && !test ? <>Для активации пробного бесплатного периода привяжите, пожалуйста, карту в личном кабинете.</> :
                                !isSubscription && !test ? <>На Вашем балансе недостаточно средств, приобретите, пожалуйста, подписку.</> : */}
                {messages.length === 0 || !isSubscription ? (
                    <div className="empty-messages">
                        <p>
                            {!isSubscription ? <>На Вашем балансе недостаточно средств, приобретите, пожалуйста, подписку.</> :
                                ['contractAnalysis_all', 'taxRisksAnalysis'].includes(selectedSubOption) ? (
                                    <>Загрузите текст договора в следующих форматах: pdf, doc, docx</>
                                ) : (
                                    <>
                                        Напишите ваш вопрос по {topic}.<br />
                                        Я учитываю контекст сообщений в одной беседе, и можно задавать уточняющие вопросы.<br />
                                        AI-технологии только развиваются, поэтому проверяйте, пожалуйста, мои ответы!
                                    </>
                                )}
                        </p>

                    </div>
                ) : (
                    messages.map((msg, index) => (
                        <MessageItem key={index} msg={msg} index={index} formatText={formatText} userId={userId} />
                    ))
                )}
                {ratingMessageId && isSubscription ? (
                    <div className="rating-buttons">
                        <p>Оцените этот ответ:</p>
                        {[1, 2, 3, 4, 5].map((rating) => (
                            <button key={rating} onClick={() => handleRating(rating)}>{rating}</button>
                        ))}
                    </div>
                ) : ''}
                {isAwaitingRole && (
                    <div className='message received'>
                        <p className="message-text">Вы обращаетесь как:</p>
                        <div className="roles_buttons">
                            <button onClick={() => handleRoleSelection('Физическое лицо')}>Физ. лицо</button>
                            <button onClick={() => handleRoleSelection('Представитель компании')}>Компания</button>
                            <button onClick={handleSkipToDialog}>Пропустить</button>
                        </div>
                    </div>
                )}
                {isAwaitingDetails && (
                    <div className='message received'>
                        <p className='message-text'>{role === "Физическое лицо" ? "Укажите, пожалуйста, ваше ФИО и ИНН в формате ФИО, ИИН" : "Укажите, пожалуйста, Наименование компании и ИНН в формате Компания, ИИН"}</p>
                        <div className="">
                            <button onClick={handleSkipToDialog}>Пропустить</button>
                        </div>
                    </div>
                )}
                {isAwaitingQuestion && (
                    <div className='message received'>
                        <p className='message-text'>Введите текст вопроса для юриста</p>
                        <div className=''>
                            <button onClick={handleSkipToDialog}>Пропустить</button>
                        </div>
                    </div>
                )}
                {isAwaitingRateComment && (
                    <div className='message received'>
                        <div className=''>
                            <button onClick={handleSkipRateComment}>Пропустить</button>
                        </div>
                    </div>
                )}
                {isWaiting && (
                    <div className="waiting-message">
                        <p>{waitingText || `Ожидание... ${progress} %`}</p>
                        {showProgressBar && (
                            <div className="progress_bar">
                                <div className="progress_fill" style={{ width: `${progress}%` }}></div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            {renderMessageInput()}
        </div>
    )
}

export default ChatContainer